// Redux Reducers
import * as Config from '../../../../../config';
import {
  ADD_NC_ROOT,
  UNSHIFT_NC_ROOT,
  CLEAR_NC_ROOT,
  CLEAR_TYPE_NC_ROOT,
  ADD_NC_CONTENT,
  CLEAR_NC_CONTENT,
  RESET_NC_STATE,
  SET_NC_STATE_POSITION_BACK,
  SET_NC_STATE_POSITION_NEXT,
  SET_NC_STATE_POSITION_PREVIOUS,
  SET_NC_STATE_LEVEL_NEXT
} from "../types";

const initialState = {
  NCRoot: [],
  NCContent: [],
  NCState: { history: [[0, 2, null], [1, null, null]], last: [0, null, null], current: [1, null, null], action: null }, // Start Level 1 to be consistent to the history
};

function navControlReducer(state = initialState, action) {

  if (action.type === ADD_NC_ROOT) {
    const hasDuplicate = (action.payload && action.payload.ref) ? state.NCRoot.find( x => x.ref === action.payload.ref) : false;
    return (!hasDuplicate) ? { ...state, NCRoot: [...state.NCRoot, action.payload].sort(Config.sortAlpha(`order`, true)) } : { ...state }
  }

  if (action.type === UNSHIFT_NC_ROOT) {
    const hasDuplicate = (action.payload && action.payload.ref) ? state.NCRoot.find( x => x.ref === action.payload.ref) : false;
    return (!hasDuplicate) ? { ...state, NCRoot: [action.payload, ...state.NCRoot] } : { ...state }
  }

  if (action.type === CLEAR_NC_ROOT) {
    return { ...state, NCRoot: [] }
  }

  if (action.type === CLEAR_TYPE_NC_ROOT) {
    const newNCRoot = state.NCRoot.reduce( (base, x) => {
      (x.type !== action.payload) && base.push(x);
      return base;
    }, []);
    return { ...state, NCRoot: newNCRoot }
  }

  if (action.type === ADD_NC_CONTENT) {
    const isExist = state.NCContent.find( x => x.ref === action.payload.ref );
    return { ...state, NCContent: isExist ? [...state.NCContent] : [...state.NCContent, action.payload] }
  }

  if (action.type === CLEAR_NC_CONTENT) {
    return { ...state, NCContent: [] }
  }

  if (action.type === SET_NC_STATE_POSITION_NEXT) {
    const last = state.NCState.current;
    const [level, index] = state.NCState.current;
    let nextPosition = (index === null) ? 0 : index + 1;
    nextPosition = (nextPosition > state[(level === 0) ? `NCRoot` : `NCContent`].length - 1) ? 0 : nextPosition;
    // nextPosition += (level === 0 && nextPosition === 0 && !document.getElementById(`ref-prev`)) ? 1 : 0;
    const nElement = state[(level === 0) ? `NCRoot` : `NCContent`][nextPosition]
    const action = (nElement) ? nElement.action : null;
    let current = [level, nextPosition, action];
    return { ...state, NCState: { ...state.NCState, last, current, action: `direction` } }
  }

  if (action.type === SET_NC_STATE_POSITION_PREVIOUS) {
    const last = state.NCState.current;
    const [level, index] = state.NCState.current;
    let previousPosition = (index === null) ? 0 : index - 1;
    previousPosition = (previousPosition < 0) ? state[(level === 0) ? `NCRoot` : `NCContent`].length - 1 : previousPosition
    // previousPosition = (level === 0 && previousPosition === 0 && !document.getElementById(`ref-prev`)) ? state[`NCRoot`].length - 1 : previousPosition;
    const nElement = state[(level === 0) ? `NCRoot` : `NCContent`][previousPosition];
    const action = (nElement) ? nElement.action : null;
    let current = [level, previousPosition, action];
    return { ...state, NCState: { ...state.NCState, last, current, action: `direction` } }
  }

  if (action.type === RESET_NC_STATE) {
    let history = state.NCState.history;
    history[1] = [1, null, null];
    return { ...state, NCContent: [], NCState: { ...state.NCState, history, current: [1, null, null], action: null } }
  }

  if (action.type === SET_NC_STATE_LEVEL_NEXT) {
    const [,index] = state.NCState.current;
    if (index !== null) {
      let action = `select`;
      const last = state.NCState.current;
      let current = [1, null, null];

      let history = state.NCState.history;
      const [lastLevel] = last;
      if (lastLevel === 0) {
        const [,hIndex] = history[lastLevel];
        if (hIndex === index) { // History + Current = Same. Just Position
          current = (history[1]) ? history[1] : current;
          action = `direction`;
        }
        history[lastLevel] = last;
      }

      return { ...state, NCState: { history, last, current, action } }
    } else {
      return { ...state }
    }
  }

  if (action.type === SET_NC_STATE_POSITION_BACK) {
    const last = state.NCState.current;
    let history = state.NCState.history;
    const [lastLevel] = last;
    if (lastLevel === 1) {
      history[lastLevel] = last;
    }
    let current = (history[0] && history[0][1] !== null) ? history[0] : [0, 1, null];
    return { ...state, NCState: { history, last, current, action: 'direction' } } //back
  }

  return state;
};

export default navControlReducer;
